import App from "./containers/App";

if (process.env.PLATFORM === "mobile") {
	require("./App.mobile.scss");
} else {
	require("./App.desktop.scss");
}

export default App;



// WEBPACK FOOTER //
// ./src/apps/incognito_packages/index.js